import dayjs from 'dayjs'

export function getCurrentQuarterRange(): [string, string] {
  const now = dayjs()
  const currentMonth = now.month()
  const startMonth = Math.floor(currentMonth / 3) * 3
  const start = now.month(startMonth).startOf('month')
  const end = now.month(startMonth + 2).endOf('month')
  return [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')]
}

export function getQuarterRange(quarter: 1 | 2 | 3 | 4) {
  const year = dayjs().year()
  const startMonth = (quarter - 1) * 3
  return [
    dayjs().year(year).month(startMonth).startOf('month'),
    dayjs()
      .year(year)
      .month(startMonth + 2)
      .endOf('month'),
  ]
}

export function getHalfYearRange(half: 1 | 2) {
  const year = dayjs().year()
  const startMonth = half === 1 ? 0 : 6
  return [
    dayjs().year(year).month(startMonth).startOf('month'),
    dayjs()
      .year(year)
      .month(startMonth + 5)
      .endOf('month'),
  ]
}

export function getMTD() {
  return [dayjs().startOf('month'), dayjs()]
}

export function getQTD() {
  const now = dayjs()
  const currentMonth = now.month()
  const startMonth = Math.floor(currentMonth / 3) * 3
  const startOfQuarter = now.month(startMonth).startOf('month')
  return [startOfQuarter, now]
}

export function getYTD() {
  return [dayjs().startOf('year'), dayjs()]
}

export function getRangePresets() {
  return [
    { label: 'Q1', value: getQuarterRange(1) as [dayjs.Dayjs, dayjs.Dayjs] },
    { label: 'Q2', value: getQuarterRange(2) as [dayjs.Dayjs, dayjs.Dayjs] },
    { label: 'Q3', value: getQuarterRange(3) as [dayjs.Dayjs, dayjs.Dayjs] },
    { label: 'Q4', value: getQuarterRange(4) as [dayjs.Dayjs, dayjs.Dayjs] },
    { label: 'H1', value: getHalfYearRange(1) as [dayjs.Dayjs, dayjs.Dayjs] },
    { label: 'H2', value: getHalfYearRange(2) as [dayjs.Dayjs, dayjs.Dayjs] },
    { label: 'MTD', value: getMTD() as [dayjs.Dayjs, dayjs.Dayjs] },
    { label: 'QTD', value: getQTD() as [dayjs.Dayjs, dayjs.Dayjs] },
    { label: 'YTD', value: getYTD() as [dayjs.Dayjs, dayjs.Dayjs] },
    {
      label: 'Life to Date',
      value: [dayjs('2023-01-01'), dayjs()] as [dayjs.Dayjs, dayjs.Dayjs],
    },
  ]
}

export function findMatchingPreset(
  startDate: dayjs.Dayjs,
  endDate: dayjs.Dayjs
): string | null {
  const presets = getRangePresets()

  for (const preset of presets) {
    const [presetStart, presetEnd] = preset.value
    if (
      startDate.isSame(presetStart, 'day') &&
      endDate.isSame(presetEnd, 'day')
    ) {
      return preset.label
    }
  }

  return null
}
